import { setAppType } from "@funded-here-interface/common/src/constant/appType";
import { typographyTheme } from "@funded-here-interface/common/src/constant/typography";
import { setupBlobErrorNormalizer } from "@funded-here-interface/common/src/Utils/axiosBlobErrorInterceptor";
import { setupUnauthorizedInterceptor } from "@funded-here-interface/common/src/Utils/axiosUnauthorizedInterceptor";

import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "mantine-react-table/styles.css";
import { MantineProvider } from "@mantine/core";
import { emotionTransform, MantineEmotionProvider } from "@mantine/emotion";

import "@funded-here-interface/common/src/styles/inputTouchFloor.css";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { handleUnauthorizedRedirect } from "./reactQuery";

setAppType("investor");
// Order is load-bearing. The blob normaliser must be FIRST so the 401
// handlers below can read `data.code` on responseType:"blob" errors at all;
// the generic 401 interceptor must register before render so it stays AHEAD
// of the session-kill interceptor (SessionInterceptorProvider mount effect)
// in axios's response chain.
setupBlobErrorNormalizer();
setupUnauthorizedInterceptor(handleUnauthorizedRedirect);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
// `theme` sets the font for every Mantine component at once. It has to be here
// rather than only on `body`: Mantine's own CSS puts
// `font-family: var(--mantine-font-family)` on Text, Button, Input and the
// rest, so those components do NOT inherit the body font — which is why each
// screen used to re-declare a font on its root class and the app drifted
// between Inter and Poppins. `theme` is inherited by nested MantineProviders
// (unlike `stylesTransform`), so the SignupCheckbox's nested provider keeps it.
root.render(
  <MantineProvider stylesTransform={emotionTransform} theme={typographyTheme}>
    <MantineEmotionProvider>
      <App />
    </MantineEmotionProvider>
  </MantineProvider>,
);
